export enum CredentialMethod {
  EDIT = 'edit',
  CREATE = 'create'
}

export enum CredentialMessage {
  CREATE_SUCCESSFUL = 'Credential saved successfully.',
  UPDATE_SUCCESSFUL = 'Credential updated successfully.',
  DELETE_SUCCESSFUL = 'Credential deleted successfully.',
  CREDENTIAL_SOURCE_NOT_FOUND = 'credential source not found',
  INCOMPLETE_CREDENITAL_ATTRIBUTES = 'credential attributes are incomplete',
  LOGIN_METHOD_NOT_FOUND = 'login method not found',
  INVALID_CREDENTIAL = 'invalid credentials',
  INVALID_SBM_CREDENTIAL = 'invalid credential of school bus manager',
  INVALID_GS_TOKEN = 'invalid_token'
}

export const formattedCredentialMessage: Record<string, string> = {
  [CredentialMessage.CREDENTIAL_SOURCE_NOT_FOUND]: 'This credential source is invalid.',
  [CredentialMessage.INCOMPLETE_CREDENITAL_ATTRIBUTES]: 'Please fill all the credential fields.',
  [CredentialMessage.LOGIN_METHOD_NOT_FOUND]: 'Login method not found',
  [CredentialMessage.INVALID_CREDENTIAL]: 'It looks like you provided Invalid credential. Please provide a valid one.',
  [CredentialMessage.INVALID_SBM_CREDENTIAL]: 'It looks like you provided Invalid School Bus Manager Credential. Please provide a valid one.',
  [CredentialMessage.INVALID_GS_TOKEN]: 'It looks like you didn\'t provided drive access. Please provide drive access and try again.'
}

export enum LoginMethodName {
  USERNAME_PASSWORD = 'usernameAndPassword',
  API_KEY = 'apiKey',
  TOKEN = 'token',
  GOOGLE_O_AUTH = 'googleOAuth'
}
export enum LoginDisplayName {
  USERNAME_PASSWORD = 'Username & Password',
  API_KEY = 'API Key',
  TOKEN = 'Token',
}
export enum CredentialDisplayName {
  USERNAME = 'Username',
  PASSWORD = 'Password',
  EMAIL = 'Email',
  API_KEY = 'API Key',
  API_SECRET = 'API Secret',
  ACCOUNT_ID = 'Account Id',
  SECRET_KEY = 'Secret Key',
  ACCESS_TOKEN = 'Access Token',
  REFRESH_TOKEN = 'Refresh Token',
  EXPIRATION_DATE = 'Expiration Date',
  RERESH_TOKEN_EXPIRE_DATE = 'Refresh Token Expire Date',
  TOKEN = 'token',
  SPREADSHEET_ID = 'Spreadsheet Id',
}
export enum CredentialAttributeName {
  USERNAME = 'username',
  PASSWORD = 'password',
  EMAIL = 'email',
  API_KEY = 'apiKey',
  SUBSCRIPTION_KEY = 'subscriptionKey',
  API_SECRET = 'apSecret',
  ACCOUNT_ID = 'accountId',
  SECRET_KEY = 'secretKey',
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  EXPIRATION_DATE = 'expireDate',
  RERESH_TOKEN_EXPIRE_DATE = 'refreshTokenExpireDate',
  TOKEN = 'token',
  SPREADSHEET_ID = 'spreadsheetId',
  CAMPBRAIN_URL = 'campbrainUrl'
}
